import { useSearchParams } from 'react-router-dom';

import { findGlossaryTerm, GlossaryKey } from './glossary';

const GLOSSARY = 'glossary';

/**
 * The term the glossary drawer shows, from the `glossary` query param (a GLOSSARY_TERMS key), so a term is
 * linkable and the other reporting params survive opening and closing it. A missing or unknown key means closed.
 */
export const useReportingGlossary = () => {
    const [params, setParams] = useSearchParams();

    const setGlossaryKey = (key: GlossaryKey | null) => {
        const next = new URLSearchParams(params);
        if (key) {
            next.set(GLOSSARY, key);
        } else {
            next.delete(GLOSSARY);
        }
        setParams(next, { replace: true });
    };

    return {
        term: findGlossaryTerm(params.get(GLOSSARY)),
        openGlossary: (key: GlossaryKey) => setGlossaryKey(key),
        closeGlossary: () => setGlossaryKey(null),
    };
};
